import React from 'react';
import TableImg from '.././../Assets/images/Table-img-aboutUs.png'
import SendContact from './SendContact';

const StayConnected = () => {
  return (
    <div className="w-full  2xl:py-20 md:py-16 py-8 md:-mb-20 -mb-6 md:px-20 px-10 sm:px-6 lg:px-28 2xl:px-64 bg-AboutUsBg">
      {/* Section One: Title, Image, and Paragraph */}
      <div className=" grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
        <div className="flex flex-col justify-center">
          <h2 className="md:text-3xl px-0  text-lg font-bold text-gray-800 mb-4 text-center md:text-left heading">
            Stay Connected With Us
          </h2>
          <img
            src={TableImg}
            alt="About Us"
            className="rounded-lg md:h-60 md:w-60 h-52 w-72  pb-2"
          />

          <p className="text-gray-600 text-xs md:text-sm md:mb-6">
            FinWise makes UPAS/LC applications easy. Submit your form, connect
            with banks and corporations, and track your UPAS/LC status
            effortlessly. Quick approvals and tailored solutions to help you
            reach your financial goals.
          </p>
        </div>
        <div className="2xl:ml-96 lg:ml-64">
          <SendContact />
        </div>
      </div>
    </div>
  );
};

export default StayConnected;
